import React from 'react';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import SpecialistInfoCard from '../Components/SpecialistInfoCard';
import PaymentMethodForm from '../Components/PaymentMethodForm/PaymentMethodForm';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Loader2 } from 'lucide-react';
import PaymentPriceCard from '../Components/PaymentMethodForm/PaymentSummaryCard';

export default function PaymentStep({ goPrev, onFinalize, isSubmitting }) {
  const handleFinalSubmit = (vals) => {
    // vals are validated PaymentMethodForm values
    onFinalize?.(vals);
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:gap-4">
        <div className="sm:w-2/3">
          <Card>
            <CardHeader>
              <button
                type="button"
                onClick={goPrev}
                disabled={isSubmitting}
                className="flex items-center gap-1 hover:opacity-80 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronLeft className="w-8 h-8 text-secondary" />
                <Heading variant="2">Apmokėjimas</Heading>
              </button>
            </CardHeader>
            <CardContent>
              <PaymentMethodForm onValid={handleFinalSubmit} />
            </CardContent>
            <CardFooter>
              <Button
                type="submit"
                form="payment-method-form"
                className="hidden sm:flex sm:w-full items-center justify-center space-x-2"
                disabled={isSubmitting}
              >
                {isSubmitting && (
                  <Loader2
                    className="mr-2 h-4 w-4 animate-spin"
                    aria-hidden="true"
                  />
                )}
                Pateikti užsakymą
              </Button>
            </CardFooter>
          </Card>
        </div>

        <div className="sm:w-1/3 mt-2 sm:mt-0">
          <div className="flex flex-col gap-4">
            <SpecialistInfoCard />
            <PaymentPriceCard />
          </div>
        </div>
      </div>

      <div className="mt-6 sm:hidden">
        <Button
          type="submit"
          form="payment-method-form"
          className="flex sm:hidden w-full items-center justify-center gap-2"
          disabled={isSubmitting}
        >
          {isSubmitting && (
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          )}
          <span>Pateikti užsakymą</span>
        </Button>
      </div>
    </div>
  );
}
